export const environment = {
    apiURL: 'http://test.api.smartenit.io:3000/v2'
  };


// WEBPACK FOOTER //
// ./src/environments/environment.ts